import React from "react";

import { Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

import ModalFooterActions from "./ModalFooterActions";
import PropertyModalShell from "./PropertyModalShell";
import { FiAlertTriangle } from "./modalFieldIcons";

export default function PropertyConfirmModal({
	isOpen,
	onClose,
	onConfirm,
	title,
	message,
	emphasis,
	confirmLabel,
	cancelLabel,
	isLoading = false,
	isDestructive = true,
}) {
	const { t } = useTranslation();

	return (
		<PropertyModalShell
			isOpen={isOpen}
			onClose={onClose}
			size="md"
			icon={FiAlertTriangle}
			title={title || t("property.confirmDelete")}
			footer={
				<ModalFooterActions
					onCancel={onClose}
					onConfirm={onConfirm}
					cancelLabel={cancelLabel || t("misc.cancel")}
					confirmLabel={confirmLabel || t("misc.delete")}
					isLoading={isLoading}
					confirmColorScheme={isDestructive ? "red" : "blue"}
				/>
			}
		>
			<Text fontSize="sm">{message}</Text>
			{emphasis && (
				<Text fontSize="sm" mt={2}>
					{emphasis}
				</Text>
			)}
		</PropertyModalShell>
	);
}
